import React from "react";

const registration = [
    { label: "Registered name:", value: "XPO Markets Ltd" },
    { label: "Company No.:", value: "16297" },
    {
        label: "Jurisdiction:",
        value: "The Autonomous Island of Anjouan, Union of Comoros",
        full: true,
    },
    {
        label: "Registered address:",
        value: "Boulevard de Coalancanthe, Mutsamudu, Autonomous Island of Anjouan, Union of Comoros",
        full: true,
    },
];

const REGULATION_TEXT =
    "XPO Markets Ltd is registered as an International Business Company by the Registrar of International Business Companies, Autonomous Island of Anjouan, Union of Comoros, under the International Business Companies Act 004 of 2005. Certificate of Good Standing on file.";

const RISK_TEXT =
    "Trading derivatives and leveraged products carries a high level of risk and may not be suitable for all investors. You may lose substantially more than your initial deposit. Please ensure you fully understand the risks involved and seek independent advice if necessary. Past performance is not a reliable indicator of future results.";

function LegalNote({ testId, label, children }) {
    return (
        <p data-testid={testId}>
            <span className="text-slate-300 font-semibold">{label}</span>{" "}
            {children}
        </p>
    );
}

export default function FooterLegal() {
    return (
        <div className="border-t border-white/5 pt-8 space-y-5 text-xs text-slate-500 leading-relaxed">
            <div
                data-testid="footer-registration"
                className="grid sm:grid-cols-2 gap-x-8 gap-y-2 text-slate-400"
            >
                {registration.map((r) => (
                    <p key={r.label} className={r.full ? "sm:col-span-2" : ""}>
                        <span className="text-slate-300 font-semibold">
                            {r.label}
                        </span>{" "}
                        {r.value}
                    </p>
                ))}
            </div>
            <LegalNote testId="footer-regulation" label="Regulation:">
                {REGULATION_TEXT}
            </LegalNote>
            <LegalNote testId="footer-risk-warning" label="Risk Warning:">
                {RISK_TEXT}
            </LegalNote>
            <p>
                © {new Date().getFullYear()} XPO Markets. All rights reserved.
                xpomarkets.co
            </p>
        </div>
    );
}
